<template>
  <div>
    <!-- BEGIN: Modal Content -->
    <div id="find-citizen" class="modal" tabindex="-1" aria-hidden="true" data-backdrop="static" v-if="modalStatus">
      <div class="modal-dialog modal-xl">
        <div class="modal-content bg-theme-39">
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              ค้นหาข้อมูล
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
               <div class="grid grid-cols-12 gap-4 gap-y-5">
                  <div class="col-span-12 sm:col-span-6">
                      <label
                      class="form-label"
                      >สัญชาติ<span class="text-red"> *</span></label>
                      <RadioCustomButton
                          class="w-40"
                          name="search-nation-radio-group"
                          first-option-id="search-form-input-nation-th"
                          second-option-id="search-form-input-nation-oth"
                          :first-option-value="formOption.nationOption[0].text"
                          :second-option-value="formOption.nationOption[1].text"
                          v-model="validatemodal.nationality.$model"
                          :class="{ 'border-theme-24': validatemodal.nationality.$error }"
                      />
                      <template v-if="validatemodal.nationality.$error">
                          <div
                          v-for="(error, index) in validatemodal.nationality.$errors"
                          :key="index"
                          class="text-theme-24 mt-1 text-xs"
                          >
                          {{ error.$message }}
                          </div>
                      </template>
                  </div>
                  <div class="col-span-12 sm:col-span-6" v-if="formModal.nationality == 'ไทย'">
                      <label
                      for="form-input-citizen-id"
                      class="form-label"
                      >เลขบัตรประจำตัวประชาชน<span class="text-red"> *</span></label>
                      <input
                      id="search-form-input-citizen-id"
                      type="text"
                      class="form-control"
                      placeholder="กรุณากรอกเลขบัตรประจำตัวประชาชน"
                      data-test="search-citizen-id"
                      v-model="formModal.national_id"
                      v-model.trim="validatemodal.national_id.$model"
                      :class="{ 'border-theme-24': validatemodal.national_id.$error || validatemodal.national_id.$invalid || checkSearchIDCard == false || duplicateIdCardData}"
                      :state="checkSearchIDCard"
                      oninput="if(this.value.length > 13){this.value = this.value.slice(0, 13);}"
                      @input="onlyNumber"
                      >
                      <template v-if="validatemodal.national_id.$error || validatemodal.national_id.$invalid">
                          <div class="text-theme-24 mt-1 text-xs"
                          >
                          {{validatemodal.national_id.required.$message}}
                          </div>
                      </template>
                      <template v-if="checkSearchIDCard == false">
                          <div
                          class="text-theme-24 mt-1 text-xs"
                          >
                          รูปแบบข้อมูลไม่ถูกต้อง
                          </div>
                      </template>
                      <template v-if="duplicateIdCardData">
                        <div
                          class="text-theme-24 mt-1 text-xs whitespace-pre-line"
                        >
                          ไม่สามารถเพิ่มสมาชิกด้วยเลขบัตรประชาชนนี้ได้ เนื่องจากพบข้อมูลของบุคคลนี้ที่
                          {{duplicateIdCardData.village_name? `หมู่บ้าน${duplicateIdCardData.village_name}`:''}}
                          {{duplicateIdCardData.tumbol_name ? `ตำบล${duplicateIdCardData.tumbol_name}` : ''}}
                          {{duplicateIdCardData.amphur_name? `อำเภอ${duplicateIdCardData.amphur_name}`:''}}
                          {{duplicateIdCardData.province_name?`จังหวัด${duplicateIdCardData.province_name}`:''}}
                          {{`\nผู้รับผิดชอบ: `}}{{duplicateIdCardData.case_manager?.uid ? `${duplicateIdCardData.case_manager.uid} (${duplicateIdCardData.case_manager.title} ${duplicateIdCardData.case_manager.name} ${duplicateIdCardData.case_manager.surname})` : '-'}}
                        </div>
                      </template>
                  </div>
                  <div class="col-span-12 sm:col-span-6" v-if="formModal.nationality == 'อื่นๆ'">
                      <label
                      for="search-form-input-nation-other"
                      class="form-label"
                      >สัญชาติ</label>
                      <input
                      id="search-form-input-nation-other"
                      type="text"
                      class="form-control"
                      placeholder="กรุณากรอกสัญชาติ"
                      data-test="search-citizen-id"
                      v-model="formModal.nationality_other"
                      >
                  </div>
                  <div class="col-span-12 mt-3 justify-center flex">
                    <button type="button" @click="cancelSearch" class="btn btn-outline-secondary w-20 mr-1">
                      ยกเลิก
                    </button>
                    <button type="button" class="btn btn-primary w-20" @click="searchMember" >
                      ค้นหา
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Modal Content -->
  </div>
</template>
<script>
import { defineComponent, reactive, computed,toRefs, onMounted, ref, onUnmounted, watch } from 'vue'
import RadioCustomButton from "@/components/base/radio-custom-button/index.vue";
import useVuelidate from '@vuelidate/core'
import { required, helpers, requiredIf } from '@vuelidate/validators'
import { useRouter, useRoute } from 'vue-router'
// import axios from "axios"
import {useStore} from "vuex"
import Swal from 'sweetalert2'
import { checkDuplicateIdcard } from "./checkIdCard"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
export default defineComponent({
  components:{
    RadioCustomButton
  },
  setup(props,{emit}) {
    const formModal = reactive({
      nationality: "ไทย",
      national_id: null,
      nationality_other: null
    })
    const formOption = reactive({
      nationOption:[
        {text:"ไทย"},
        {text:"อื่นๆ"}
      ]
    })
    const rulesmodal = {
      nationality: {
        required: helpers.withMessage(`กรุณาเลือกสัญชาติ`, required)
      },
      national_id: {
        required: helpers.withMessage(`กรุณากรอกเลขประจำตัวประชาชน`, requiredIf(() =>formModal.nationality=='ไทย'))
      },
    }
    const validatemodal = useVuelidate(rulesmodal, toRefs(formModal))
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const token = store.getters["userAuth/getToken"];
    const modalStatus =ref(true)
    const householdId = route.query.hhid
    const duplicateIdCardData = ref(null)
    function checkIDCard(value){
      if(value == null){
          return null
      }
      if (value.length == 13 || value.length > 13) {
          var sum, i;
          if (value.substring(0, 1) == 0) return false;
          for (i = 0, sum = 0; i < 12; i++)
              sum += parseFloat(value.charAt(i)) * (13 - i);
          if ((11 - (sum % 11)) % 10 != parseFloat(value.charAt(12))){
              return false;
          }
          return true;
      } else if (value.length > 0 ) {
          return false;
      }else {
          return null;
      }
    }
    const checkSearchIDCard = computed({
      get() {
          return checkIDCard(formModal.national_id)
      }
    })
    onMounted(()=>{
      cash("#find-citizen").modal("show");
    })
    onUnmounted(() => {
      modalStatus.value = false
      cash("#find-citizen").modal("hide");
    })
    function cancelSearch(){
        modalStatus.value = false
        cash("#find-citizen").modal("hide");
        router.replace({
          name: 'family-profile',
          id: route.params.famid
        })
    }
    async function searchMember(){
      validatemodal.value.$touch()
      if (validatemodal.value.$invalid || checkSearchIDCard.value == false || duplicateIdCardData.value){
          return;
      }
      if(formModal.national_id){
        const result = await checkDuplicateIdcard(formModal.national_id)
        if(result){
          if((householdId == result.hh_id) && result.fam_id == null){
            swalCustom.fire({
              text:"ยืนยันการนำเข้าสมาชิกในครอบครัวนี้!",
              icon: 'info',
              showCancelButton: true,
              reverseButtons: true,
              confirmButtonText: 'ยืนยัน',
              cancelButtonText: 'ยกเลิก',
            }).then(()=>{
              cash("#find-citizen").modal("hide");
              emit("updateForm", result)
            })
          }
          else{
            duplicateIdCardData.value = result
            // swalCustom.fire({
            //   text:"ไม่สามารถเพิ่มบุคคลนี้ได้!",
            //   icon: 'warning',
            //   // timer: 3000,
            //   confirmButtonText: "ปิด",
            // })
          }
        }
        else{
          cash("#find-citizen").modal("hide");
           router.push({
        name: 'add-member',
        params: { famid: route.params.famid },
        query: { 
          hhid: route.query.hhid,
          nationality: formModal.nationality,
          national_id: formModal.national_id,
          nationality_other: formModal.nationality_other,
          fromSearch: 'true'
        }
      })
          emit("updateForm", formModal)
        }
      }
      else{
        cash("#find-citizen").modal("hide");
         router.push({
        name: 'add-member',
        params: { famid: route.params.famid },
        query: { 
          hhid: route.query.hhid,
          nationality: formModal.nationality,
          national_id: formModal.national_id,
          nationality_other: formModal.nationality_other,
          fromSearch: 'true'
        }
      })
        emit("updateForm", formModal)
      }
      validatemodal.value.$reset()
    }
    watch(()=>formModal.nationality,(val)=>{
      if(val == 'อื่นๆ'){
        formModal.national_id = null
        validatemodal.value.$reset()
        duplicateIdCardData.value = null
      }
      else{
        formModal.nationality_other = null
      }
    })
    const onlyNumber = () => {
      formModal.national_id = formModal.national_id.replace(/[^\d]/g, "")
      if(formModal.national_id.length !== 13){
        duplicateIdCardData.value = null
      }
    }
    return{
      validatemodal,
      formOption,
      formModal,
      cancelSearch,
      checkSearchIDCard,
      searchMember,
      modalStatus,
      duplicateIdCardData,
      onlyNumber
    }
  },
})
</script>

